import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";

import { EvotruxDivider } from "components/EvotruxDivider";
import { EVOTRUX_URL_HASH } from "constants/index";
import { useScrollToHash } from "hooks";
import { formatPhoneNumber } from "utils";

import type { CompanyProfileAbout } from "types/company";

const EMERGENCY_CONTACT_SECTION_ID =
  EVOTRUX_URL_HASH.CARRIER_EMERGENCY_CONTACT.slice(1);

interface Props {
  profileAbout: CompanyProfileAbout | null;
  // False while content above this section is still loading and shifting it.
  isScrollEnabled: boolean;
}

export function CarrierEmergencyContact(props: Props) {
  const { profileAbout, isScrollEnabled } = props;
  const sectionRef = useScrollToHash({
    hash: EVOTRUX_URL_HASH.CARRIER_EMERGENCY_CONTACT,
    isEnabled: isScrollEnabled,
  });

  return (
    <Stack id={EMERGENCY_CONTACT_SECTION_ID} ref={sectionRef}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Emergency Contact
      </Typography>
      <EvotruxDivider />
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
          <Card
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={2}>
                <LocalPhoneOutlinedIcon />
                <Stack>
                  <Typography variant="body2">
                    Emergency Phone Number
                  </Typography>
                  {profileAbout?.phone_number &&
                  profileAbout?.phone_number !== "" ? (
                    <Typography variant="body1">
                      {formatPhoneNumber(profileAbout.phone_number)}
                    </Typography>
                  ) : (
                    <Typography variant="body1" color="text.secondary">
                      This carrier has not specified emergency phone number
                    </Typography>
                  )}
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
          <Card
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={2}>
                <EmailOutlinedIcon />
                <Stack>
                  <Typography variant="body2">
                    Emergency Email Address
                  </Typography>
                  {profileAbout?.email && profileAbout?.email !== "" ? (
                    <Typography variant="body1">
                      {profileAbout?.email}
                    </Typography>
                  ) : (
                    <Typography variant="body1" color="text.secondary">
                      This carrier has not specified emergency email
                    </Typography>
                  )}
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Stack>
  );
}
